module.exports = __webpack_public_path__ + "images/emoji/nut_and_bolt.ea0be79312255eca7df2.png";